<span class="block font-bold">
    {{ notification().title }}
    <i class="fa fa-clock"></i> {{ notification().createdAt | appDate:'medium' }}
</span>
<span appCopyable [appCopyableValue]="notification().copyableData ?? notification().message"
      [innerHTML]="notification().message">
</span>
